import { differenceInCalendarDays, parseISO } from 'date-fns';

export type ClubSuspensionLevel = 'none' | 'risk' | 'imminent' | 'due' | 'suspended';

export type ClubSuspensionStatus =
  | { level: 'none' }
  | { level: 'risk'; daysLeft: number }
  | { level: 'imminent'; daysLeft: number }
  | { level: 'due' }
  | { level: 'suspended' };

/**
 * Dunning status of the club, driven by elisa:
 * - `locked` is the actual block of the app ('suspended'): set by the administration
 *   once the formal notice is confirmed.
 * - `suspensionDate` only drives the warnings: 'risk' (14..8 days before), 'imminent'
 *   (7..1 days before), 'due' (date reached, account not locked yet).
 */
export const getClubSuspensionStatus = (
  suspensionDate?: string | null,
  locked?: boolean | null,
): ClubSuspensionStatus => {
  if (locked) return { level: 'suspended' };
  if (!suspensionDate) return { level: 'none' };

  const daysLeft = differenceInCalendarDays(parseISO(suspensionDate), new Date());

  if (daysLeft <= 0) return { level: 'due' };
  if (daysLeft <= 7) return { level: 'imminent', daysLeft };
  if (daysLeft <= 14) return { level: 'risk', daysLeft };
  return { level: 'none' };
};
